const Spinner: React.FC = () => <div className="spinner" />;

export default Spinner;
